<page-heading
  [title]="'report.list.title' | translate"
  [description]="'report.list.description' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="reportForm">
          <div class="row g-2 d-flex justify-content-end">
            <div
              class="col-xs-12 col-lg-3 trend-datepicker"
              [matTooltip]="'report.list.previousPeriod' | translate"
            >
              <mat-date-range-input
                [rangePicker]="pickerPrevious"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.list.previousPeriod' | translate"
                  formControlName="dateStartPrevious"
                />
                <input
                  matEndDate
                  [placeholder]="'report.list.endDate' | translate"
                  formControlName="dateEndPrevious"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="pickerPrevious" />
              <mat-date-range-picker
                #pickerPrevious
                (selectionChange)="onPeriodChangePrevious($event)"
              >
                <mat-datepicker-actions>
                  <mat-form-field>
                    <mat-label>{{ 'report.list.select' | translate }}</mat-label>
                    <mat-select
                      (selectionChange)="onPeriodChangePrevious($event)"
                    >
                      <mat-option value="1">{{ 'report.list.today' | translate }}</mat-option>
                      <mat-option value="7">{{ 'report.list.last7Days' | translate }}</mat-option>
                      <mat-option value="15">{{ 'report.list.last15Days' | translate }}</mat-option>
                      <mat-option value="30">{{ 'report.list.last30Days' | translate }}</mat-option>
                      <mat-option value="60">{{ 'report.list.last60Days' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    {{ 'report.list.ok' | translate }}
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div
              class="col-xs-12 col-lg-3 trend-datepicker"
              [matTooltip]="'report.list.currentPeriod' | translate"
            >
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.list.currentPeriod' | translate"
                  formControlName="dateStartPrevious"
                />
                <input
                  matEndDate
                  [placeholder]="'report.list.endDate' | translate"
                  formControlName="dateEndPrevious"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker
                #picker
                (selectionChange)="onPeriodChangePrevious($event)"
              >
                <mat-datepicker-actions>
                  <mat-form-field>
                    <mat-label>{{ 'report.list.select' | translate }}</mat-label>
                    <mat-select
                      (selectionChange)="onPeriodChangePrevious($event)"
                    >
                      <mat-option value="1">{{ 'report.list.today' | translate }}</mat-option>
                      <mat-option value="7">{{ 'report.list.last7Days' | translate }}</mat-option>
                      <mat-option value="15">{{ 'report.list.last15Days' | translate }}</mat-option>
                      <mat-option value="30">{{ 'report.list.last30Days' | translate }}</mat-option>
                      <mat-option value="60">{{ 'report.list.last60Days' | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    {{ 'report.list.ok' | translate }}
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel | translate }}</span>
              </button>

              <mat-menu #filterChannel="matMenu">
                <button mat-menu-item (click)="selectChannel(-1, 'report.list.all')">
                  {{ 'report.list.all' | translate }}
                </button>

                @if (channelAttendant) { @for (channel of channelAttendant;
                track $index) {
                <button
                  mat-menu-item
                  (click)="selectChannel($safeNavigationMigration(channel?._id), $safeNavigationMigration(channel?.name))"
                >
                  {{ channel?.name }}
                </button>
                } }
              </mat-menu>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterDepartmentAtt"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelDepartment | translate }}</span>
              </button>

              <mat-menu
                #filterDepartmentAtt="matMenu"
                class="custom-menu-panel"
              >
                <button mat-menu-item (click)="selectDepartment(-1, 'report.list.all')">
                  {{ 'report.list.all' | translate }}
                </button>

                @if (department?.length) { @for (dept of department; track
                dept?._id) {
                <button
                  mat-menu-item
                  (click)="selectDepartment($safeNavigationMigration(dept?._id), $safeNavigationMigration(dept?.name))"
                >
                  {{ dept?.name }}
                </button>
                } }
              </mat-menu>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterUserAdm"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelAttendant | translate }}</span>
              </button>

              <mat-menu #filterUserAdm="matMenu" class="custom-menu-panel">
                <button mat-menu-item (click)="selectAttendant(-1, 'report.list.all')">
                  {{ 'report.list.all' | translate }}
                </button>

                @if (userAttendant?.length) { @for (user of userAttendant; track
                user?._id) {
                <button
                  mat-menu-item
                  (click)="selectAttendant($safeNavigationMigration(user?._id), $safeNavigationMigration(user?.name))"
                >
                  {{ user?.name }}
                </button>
                } }
              </mat-menu>
            </div>

            <div
              class="col-xs-6 col-md-6 col-lg-1 gap-2 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                [matTooltip]="'report.list.export' | translate"
                (click)="exportFile()"
              >
                <i class="ri-share-box-fill"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

@if (!loadingContent) {
<div class="card-body mb-3">
  <div class="d-flex flex-wrap gap-2">
    <div
      class="flex-fill card-hover"
      (click)="
        openModalCountAttendance(
          'channel',
          $safeNavigationMigration(countItemsAttendance?.totalChannelIds)
        )
      "
    >
      <card-graphic-small-component
        [label]="'report.list.channels' | translate"
        [total]="countItemsAttendance?.totalChannels.toString() ?? '0'"
      />
    </div>
    <div
      class="flex-fill card-hover"
      (click)="
        openModalCountAttendance(
          'department',
          $safeNavigationMigration(countItemsAttendance?.totalDepartmentIds)
        )
      "
    >
      <card-graphic-small-component
        [label]="'report.list.departments' | translate"
        [total]="countItemsAttendance?.totalDepartments.toString() ?? '0'"
      />
    </div>
    <div
      class="flex-fill card-hover"
      (click)="
        openModalCountAttendance('user', $safeNavigationMigration(countItemsAttendance?.totalUserIds))
      "
    >
      <card-graphic-small-component
        [label]="'report.list.attendants' | translate"
        [total]="countItemsAttendance?.totalUsers.toString() ?? '0'"
      />
    </div>
    <div
      class="flex-fill card-hover"
      (click)="
        openModalCountAttendance(
          'leadPrevious',
          $safeNavigationMigration(countItemsAttendance?.attendanceIdsPrevious)
        )
      "
    >
      <card-graphic-small-component
        [label]="'report.list.previousPeriodLabel' | translate"
        [total]="
          countItemsAttendance?.totalAttendancePrevious.toString() ?? '0'
        "
      />
    </div>
    <div
      class="flex-fill card-hover"
      (click)="
        openModalCountAttendance(
          'leadCurrent',
          $safeNavigationMigration(countItemsAttendance?.attendanceIdsCurrent)
        )
      "
    >
      <card-graphic-small-component
        [label]="'report.list.currentPeriodLabel' | translate"
        [total]="countItemsAttendance?.totalAttendanceCurrent.toString() ?? '0'"
      />
    </div>
  </div>
</div>

<div class="card mb-3">
  <div class="card-body">
    <div class="row g-2 d-flex justify-content-center mb-3">
      <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
        <button
          [matMenuTriggerFor]="menuGraphic"
          type="button"
          class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
        >
          <span>{{ selectedGraphicLabel | translate }}</span>
        </button>

        <mat-menu #menuGraphic="matMenu">
          @for (type of typeCharts; track $index) {
          <button
            mat-menu-item
            [value]="type.value"
            (click)="onGraphicSelect(type.value, $safeNavigationMigration(type?.name))"
          >
            {{ $safeNavigationMigration(type?.name) | translate }}
          </button>
          }
        </mat-menu>
      </div>
      <div class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button">
        <button
          [matMenuTriggerFor]="menuList"
          type="button"
          class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
        >
          <span>{{ selectedListLabel | translate }}</span>
        </button>

        <mat-menu #menuList="matMenu">
          @for (type of typeCharts; track $index) {
          <button
            mat-menu-item
            [value]="type.value"
            (click)="onListSelect(type.value, $safeNavigationMigration(type?.name))"
          >
            {{ $safeNavigationMigration(type?.name) | translate }}
          </button>
          }
        </mat-menu>
      </div>
    </div>

    <div class="row g-2">
      <div class="col-xs-12 col-lg-6 border-end">
        @switch (selectedGraphic) { @case ('channel') {
        <div class="flex-fill">
          <ngx-charts-bar-horizontal
            [results]="graphicChannel"
            [xAxis]="true"
            [yAxis]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [scheme]="colorScheme"
            [autoResize]="true"
          />
        </div>
        } @case ('user') {
        <div class="flex-fill">
          <ngx-charts-bar-horizontal
            [results]="graphicUser"
            [xAxis]="true"
            [yAxis]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [scheme]="colorScheme"
            [autoResize]="true"
          />
        </div>
        } @case ('user') {
        <div class="flex-fill">
          <ngx-charts-bar-horizontal
            [results]="graphicUser"
            [xAxis]="true"
            [yAxis]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [scheme]="colorScheme"
            [autoResize]="true"
          />
        </div>
        } @case('department') {
        <ngx-charts-bar-horizontal
          [results]="graphicDepartment"
          [xAxis]="true"
          [yAxis]="true"
          [showXAxisLabel]="true"
          [showYAxisLabel]="true"
          [scheme]="colorScheme"
          [autoResize]="true"
        />
        } @default {
        <div class="alert alert-secondary mb-0">
          {{ 'report.list.selectChartToDisplay' | translate }}
        </div>
        } }
      </div>
      <div class="col-xs-12 col-lg-6 p-4">
        @switch (selectedList) { @case ('channel') {
        <table class="table table-sm w-100 align-middle table-divide">
          <thead class="bg-light"></thead>
          <tbody class="bg-white">
            @for (item of graphicChannel; track item) {
            <tr>
              <td class="text-nowrap px-3 py-3 small text-muted">
                <p class="mb-0">{{ item?.name }}</p>
              </td>
              <td class="px-3 py-3 small">
                <p class="mb-0">{{ item?.value }}</p>
              </td>
            </tr>
            }
            <tr></tr>
          </tbody>
        </table>
        } @case ('user') {
        <table class="table table-sm w-100 align-middle table-divide">
          <thead class="bg-light"></thead>
          <tbody class="bg-white">
            @for (item of graphicUser; track item) {
            <tr>
              <td class="text-nowrap px-3 py-3 small text-muted">
                <p class="mb-0">{{ item?.name }}</p>
              </td>
              <td class="px-3 py-3 small">
                <p class="mb-0">{{ item?.value }}</p>
              </td>
            </tr>
            }
            <tr></tr>
          </tbody>
        </table>
        } @case ('department') {
        <table class="table table-sm w-100 align-middle table-divide">
          <thead class="bg-light"></thead>
          <tbody class="bg-white">
            @for (item of graphicDepartment; track item) {
            <tr>
              <td class="text-nowrap px-3 py-3 small text-muted">
                <p class="mb-0">{{ item?.name }}</p>
              </td>
              <td class="px-3 py-3 small">
                <p class="mb-0">{{ item?.value }}</p>
              </td>
            </tr>
            }
            <tr></tr>
          </tbody>
        </table>
        } @default {
        <div class="alert alert-secondary mb-0">
          {{ 'report.list.selectListToDisplay' | translate }}
        </div>
        } }
      </div>
    </div>
  </div>
</div>
}

<div class="card">
  @if (loadingContent) {
  <content-loading-list />
  } @if (!loadingContent && pager.total === 0) {
  <empty-records-component
    [message]="'report.list.noRecordsFound' | translate"
    [subMessage]="'report.list.changeFilterToSearch' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
  />
  } @if (!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'report.list.channel' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.list.department' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.list.attendant' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.list.attendancePreviousPeriod' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'report.list.attendanceCurrentPeriod' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for(item of pager.list; track item) {
        <tr>
          <td>
            <span>
              {{ item?.channel }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.department }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.user }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.totalAttendancePrevious }}
            </span>
          </td>
          <td>
            <span>
              {{ item?.totalAttendanceCurrent }}
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>
    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
    }
  </div>
  }
</div>
